module.exports = __webpack_public_path__ + "img/bottomicon (2).45bb6dd9.png";